import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import WelcomePage from './pages/WelcomePage';
import DashboardPage from './pages/DashboardPage';
import CheckpointPage from './pages/CheckpointPage';
import MembersListPage from './pages/MembersListPage';
import MemberFormPage from './pages/MemberFormPage';
import MemberProfilePage from './pages/MemberProfilePage';
import CellsListPage from './pages/CellsListPage';
import CellFormPage from './pages/CellFormPage';
import CellDetailPage from './pages/CellDetailPage';
import MapCellsPage from './pages/MapCellsPage';
import RolesPage from './pages/RolesPage';
import AccessListPage from './pages/AccessListPage';
import ReportsPage from './pages/ReportsPage';
import ReportsStatsPage from './pages/ReportsStatsPage';
import CheckpointSelector from './components/CheckpointSelector';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import EventFormPage from './pages/EventFormPage';
import SettingsPage from './pages/SettingsPage';
import AgendaPage from './pages/AgendaPage';
import ImportPage from './pages/ImportPage';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';

function App({ apiUrl, pluginUrl }) {
  // Configura API URL global
  if (apiUrl) {
    window.HAKLAI_API_URL = apiUrl;
  }
  if (pluginUrl) {
    window.HAKLAI_PLUGIN_URL = pluginUrl;
  }

  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={<LoginPage />}
          />
          <Route
            path="/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route
            path="/reset-password"
            element={<ResetPasswordPage />}
          />
          <Route
            path="/welcome"
            element={
              <PrivateRoute allowWithoutTenant={true}>
                <WelcomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkpoint/select"
            element={
              <PrivateRoute>
                <CheckpointSelector />
              </PrivateRoute>
            }
          />
          <Route
            path="/checkpoint"
            element={
              <PrivateRoute>
                <CheckpointPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/members"
            element={
              <PrivateRoute>
                <MembersListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/members/new"
            element={
              <PrivateRoute>
                <MemberFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/members/:id/edit"
            element={
              <PrivateRoute>
                <MemberFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/members/:id"
            element={
              <PrivateRoute>
                <MemberProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cells"
            element={
              <PrivateRoute>
                <CellsListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cells/map"
            element={
              <PrivateRoute>
                <MapCellsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cells/new"
            element={
              <PrivateRoute>
                <CellFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cells/:id"
            element={
              <PrivateRoute>
                <CellDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/cells/:id/edit"
            element={
              <PrivateRoute>
                <CellFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/agenda"
            element={
              <PrivateRoute>
                <AgendaPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/import"
            element={
              <PrivateRoute>
                <ImportPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/new"
            element={
              <PrivateRoute>
                <EventFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/events/:id/edit"
            element={
              <PrivateRoute>
                <EventFormPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/roles"
            element={
              <PrivateRoute>
                <RolesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/access"
            element={
              <PrivateRoute>
                <AccessListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <ReportsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports/my-stats"
            element={
              <PrivateRoute>
                <ReportsStatsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            }
          />
          <Route path="/role" element={<Navigate to="/roles" />} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;

